import templateUrl from "emun.order/modify-order/modified-orders-list.htm";
import controller from "emun.order/modify-order/modified-orders-list.controller";

export default {
  controller,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  }
};
